export default class DtoReferencialItem {
    constructor(obj) {
        this.code = obj.code
        this.name = obj.name
    }
}